/**
 *
 * Asynchronously loads the component for VideoPlayerPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
